"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Strip.default;
  }
});

var _Strip = _interopRequireDefault(require("./Strip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }